module.exports = __webpack_public_path__ + "static/media/sample_remove_users_csv.80e8fece.csv";